export const blogArticles = {
  '5-documentos-empresa-orden-2026': {
    slug: '5-documentos-empresa-orden-2026',
    title: '5 Documentos que toda empresa debe tener en orden en 2026',
    date: 'mayo 5, 2026',
    category: 'Empresarial',
    author: 'Ricardo Dehesa Cortés',
    authorTitle: 'Notario Titular - Notaría Pública 90',
    excerpt: 'El entorno empresarial demanda agilidad administrativa sin comprometer la solidez legal. Estos son los 5 pilares documentales que garantizan la continuidad y protección del patrimonio de tu empresa en 2026.',
    content: `
Por Notaría Pública 90, Playa del Carmen.

El entorno empresarial en México, y específicamente en polos de alto crecimiento como Playa del Carmen, demanda una agilidad administrativa sin precedentes. Sin embargo, la velocidad de los negocios no debe comprometer la solidez legal. Al iniciar este 2026, la fiscalización digital y las nuevas normativas de transparencia obligan a las empresas a realizar un "check-up" documental.

En la Notaría Pública 90, bajo la visión de Ricardo Dehesa Cortés, hemos identificado los cinco pilares documentales que garantizan la continuidad y protección de su patrimonio empresarial.

## 1. Acta Constitutiva y Reformas Actualizadas

No basta con tener el acta original. Con el paso del tiempo, las empresas cambian de socios, de objeto social o de domicilio. Es vital que todas las asambleas donde se hayan tomado decisiones estructurales estén debidamente protocolizadas ante Notario Público e inscritas en el Registro Público de la Propiedad y del Comercio. Una empresa con un acta desactualizada puede enfrentar bloqueos bancarios o la nulidad de contratos importantes.

## 2. Libros Corporativos (Libro de Actas, Socios y Variaciones de Capital)

A menudo olvidados, los libros corporativos son la "hoja de vida" legal de la sociedad. En 2026, ante auditorías fiscales o procesos de debida diligencia (Due Diligence), contar con estos libros al día es la única forma de probar la legalidad de la estructura interna y la tenencia de acciones.

## 3. Poderes Notariales Vigentes y Delimitados

Es común encontrar empresas donde los apoderados ya no forman parte de la organización o donde los poderes son tan amplios que generan riesgos innecesarios. Recomendamos una revisión exhaustiva para otorgar poderes específicos que faciliten la operación pero protejan la toma de decisiones crítica.

## 4. Contratos de Arrendamiento y Propiedad con Certeza Legal

Ya sea que su empresa opere en un local comercial o cuente con activos inmobiliarios, la seguridad del lugar de operación es clave. En zonas de alta plusvalía como Quintana Roo, contar con contratos de arrendamiento ratificados ante notario o escrituras en perfecto orden es la mejor defensa contra controversias futuras.

## 5. Títulos de Propiedad Intelectual y Contratos Digitales

En la era de la economía del conocimiento, el registro de su marca y la formalización de sus contratos digitales (Smart Contracts) son activos esenciales. La protección de su identidad comercial y la validez jurídica de sus acuerdos en línea son hoy tan importantes como el capital físico.

*"La verdadera competitividad de una empresa no solo reside en su flujo de efectivo, sino en su estructura legal. Una empresa ordenada es una empresa que puede escalar, atraer inversión y operar con la tranquilidad de que su patrimonio está blindado ante cualquier eventualidad."* — Ricardo Dehesa Cortés, Notaría Pública 90.

## Digitalice su Gestión con HITCH

La carga administrativa no tiene por qué ser un obstáculo para el crecimiento. En la Notaría Pública 90 integramos soluciones tecnológicas avanzadas para facilitar el cumplimiento de estos requisitos.

A través de la plataforma <a href="https://hitchain.com.mx" class="text-notaria-secondary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">HITCH</a>, nuestros clientes pueden gestionar su repositorio legal, agilizar la firma de contratos digitales y mantener un control estricto sobre su documentación corporativa con validez jurídica completa.

## Proteja su inversión en la Riviera Maya

En la Notaría Pública 90, somos sus aliados estratégicos en Playa del Carmen. Nuestro equipo está listo para ayudarle a auditar y regularizar la situación documental de su empresa, asegurando que su enfoque permanezca en los negocios mientras nosotros cuidamos su legalidad.

Agende una cita con nosotros a través de nuestro sitio web oficial y reciba asesoría especializada para este 2026.
`
  },
  'que-hace-realmente-un-notario': {
    slug: 'que-hace-realmente-un-notario',
    title: '¿Qué hace realmente un notario? Más allá de la firma y el sello',
    date: 'mayo 5, 2026',
    category: 'Función Notarial',
    author: 'Ricardo Dehesa Cortés',
    authorTitle: 'Notario Titular - Notaría Pública 90',
    excerpt: 'Más allá del acto formal de la firma y el sello, el trabajo notarial es un pilar de estabilidad social y económica. Descubre el verdadero alcance de la función notarial en la Riviera Maya.',
    content: `
Por Notaría Pública 90, Playa del Carmen.

Existe una percepción común de que la función de un notario se limita a estampar una firma y un sello en documentos ya redactados. Sin embargo, en el dinámico entorno de la Riviera Maya, esta visión es superficial. En la Notaría Pública 90, ubicada en el corazón de Playa del Carmen, entendemos que nuestra labor es ser arquitectos de la certeza jurídica y guardianes del patrimonio en una de las zonas de mayor crecimiento del país.

Más allá del acto formal, el trabajo notarial es un pilar de estabilidad social y económica.

## El Asesoramiento: El Primer Pilar de la Fe Pública

Antes de cualquier protocolo, la función principal es escuchar y asesorar. Ricardo Dehesa Cortés enfatiza que la labor notarial en Quintana Roo es, ante todo, una labor de consultoría ética y preventiva.

*"Un buen notario no solo valida lo que el cliente le dice; le ayuda a entender las consecuencias legales de sus decisiones. En Playa del Carmen, donde las transacciones inmobiliarias y corporativas son constantes, nuestra prioridad es blindar a las partes contra conflictos futuros."* — Ricardo Dehesa Cortés.

## Redacción y Resguardo: La Memoria Jurídica de la Ciudad

La redacción de una escritura no es un simple llenado de formatos. Es la traducción de la voluntad del cliente al lenguaje de la ley. Además, el notario es el guardián del protocolo; esos documentos que usted firma se conservan bajo estrictas medidas de seguridad, asegurando que sus derechos puedan ser probados y reclamados incluso décadas después.

## El Notario como Auxiliar de la Justicia

Al garantizar la legalidad de las transacciones privadas, el notario reduce la carga de los tribunales. Un documento notarial tiene un valor probatorio superior, lo que brinda una paz mental invaluable tanto a residentes locales como a inversionistas extranjeros que eligen Playa del Carmen para establecer sus proyectos.

## Confíe su Patrimonio a Expertos en Playa del Carmen

En la Notaría Pública 90, combinamos la rigurosidad de la fe pública con la agilidad que el mundo moderno exige. A través de nuestra alianza con <a href="https://hitchain.com.mx" class="text-notaria-secondary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">HITCH</a>, digitalizamos procesos legales para que su gestión sea más eficiente, sin perder nunca la seguridad jurídica.

El Ricardo Dehesa Cortés y su equipo de expertos le esperan para asesorarle en:

- **Trámites Inmobiliarios:** Certeza en compraventas y fideicomisos en la zona costera.
- **Sucesiones y Testamentos:** Planificación patrimonial para su familia.
- **Materia Corporativa:** Constitución de empresas y actas de asamblea.

Asegure su inversión y su tranquilidad hoy mismo. Contáctenos a través de nuestro sitio web oficial o visítenos en nuestras oficinas en Playa del Carmen.
`
  },
  'contratos-inteligentes-practica-notarial-moderna': {
    slug: 'contratos-inteligentes-practica-notarial-moderna',
    title: 'Contratos Inteligentes: ¿Cómo se integran en la práctica notarial moderna?',
    date: 'mayo 5, 2026',
    category: 'Smart Contracts',
    author: 'Ricardo Dehesa Cortés',
    authorTitle: 'Notario Titular - Notaría Pública 90',
    excerpt: 'Los Smart Contracts prometen eficiencia, transparencia y seguridad. Descubre cómo se integran estos códigos digitales en la práctica notarial tradicional.',
    content: `
Por Notaría Pública 90, Playa del Carmen.

La transformación digital es una fuerza imparable que está redefiniendo todas las industrias, y el sector legal y notarial no es la excepción. Una de las innovaciones más prometedoras es la tecnología de los Contratos Inteligentes (o Smart Contracts). Estos acuerdos autoejecutables, que funcionan sobre una blockchain, prometen eficiencia, transparencia y seguridad. Pero surge una pregunta crucial para nuestros clientes en Playa del Carmen y todo México: ¿Cómo se integran estos códigos digitales en la práctica notarial tradicional?

En la Notaría Pública 90, bajo la dirección del Ricardo Dehesa Cortés, entendemos que la tecnología es una herramienta poderosa, pero que el factor humano y la certeza jurídica siguen siendo el pilar fundamental.

## ¿Qué es un Contrato Inteligente y cómo difiere de uno tradicional?

Un contrato tradicional es un documento físico o digital que detalla los términos de un acuerdo. Su cumplimiento depende de la voluntad de las partes o de la intervención de un tercero. Un Contrato Inteligente, por el contrario, es un programa informático: "Si ocurre el evento A, entonces ejecuta automáticamente la acción B". Estos contratos viven en una base de datos distribuida (blockchain), lo que los hace inmutables y transparentes.

## El Nuevo Rol del Notario: Un Puente entre el Código y la Ley

La integración de los contratos inteligentes en la práctica notarial no significa la desaparición del notario, sino una evolución de su función. El notario moderno actúa como un arquitecto jurídico y digital en el corazón de la Riviera Maya, encargándose de:

1. **Asesoramiento Jurídico en la Programación:** El código no puede interpretar la intención de las partes. El notario traduce la voluntad legal en la lógica del contrato inteligente, asegurando el cumplimiento de la legislación mexicana.
2. **Verificación de Identidad y Capacidad:** Antes de que un contrato se ejecute, el notario debe verificar la identidad de las partes y su capacidad legal, un paso crítico que el código no puede realizar de forma autónoma.
3. **Fe Pública Digital:** El notario certifica que el código corresponde fielmente a lo acordado por las partes, brindando el respaldo institucional necesario para que la tecnología tenga validez jurídica plena.

*"La integración de los contratos inteligentes en la práctica notarial moderna no representa una suplantación del notario, sino una sofisticación de nuestra labor. La fe pública siempre requerirá la intervención humana para garantizar la legalidad, la equidad y el asesoramiento ético. La tecnología es el vehículo que hace el proceso más eficiente, pero la certeza jurídica la proporcionamos nosotros."* — Ricardo Dehesa Cortés, Notaría Pública 90.

## Beneficios Prácticos de la Integración

- **Eficiencia:** Automatización de procesos como la liberación de fondos o transferencias de propiedad tras un pago.
- **Transparencia:** Todas las partes verifican el estado y los términos en la blockchain de manera inalterable.
- **Seguridad:** La inmutabilidad de la red protege contra fraudes, especialmente valioso en transacciones inmobiliarias de alto impacto.

## Innovación Notarial en Playa del Carmen con HITCH

En la Notaría Pública 90, creemos en el poder de las alianzas tecnológicas para brindar un servicio de excelencia. Por ello, colaboramos estrechamente con plataformas líderes como <a href="https://hitchain.com.mx" class="text-notaria-secondary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">HITCH</a>.

HITCH es una plataforma diseñada para digitalizar la gestión legal, permitiendo a empresas y despachos simplificar sus flujos de trabajo y firmar documentos de manera remota con plena validez. La integración de herramientas como HITCH complementa nuestra capacidad para asesorar en soluciones modernas y estructuración de contratos digitales en Quintana Roo.

## Confíe su Futuro Jurídico a la Notaría Pública 90

La adopción de tecnologías avanzadas requiere un guía experto que conozca el marco legal local y global. En la Notaría Pública 90, combinamos la tradición de la fe pública con la innovación digital para asegurar su tranquilidad en Playa del Carmen.

Contáctenos hoy mismo a través de nuestro sitio web para recibir asesoramiento personalizado y asegurar sus transacciones más importantes.
`
  },
  'blockchain-y-seguridad-juridica-certificacion-documentos': {
    slug: 'blockchain-y-seguridad-juridica-certificacion-documentos',
    title: 'Blockchain y Seguridad Jurídica: El futuro de la certificación de documentos',
    date: 'mayo 5, 2026',
    category: 'Blockchain',
    author: 'Ricardo Dehesa Cortés',
    authorTitle: 'Notario Titular - Notaría Pública 90',
    excerpt: 'La tecnología blockchain promete revolucionar la certificación de documentos, ofreciendo nuevas capas de seguridad y eficiencia para la fe pública del siglo XXI.',
    content: `
En un mundo cada vez más digital, la forma en que validamos la autenticidad de los documentos está evolucionando rápidamente. Tradicionalmente, la certificación de documentos ha dependido de procesos físicos y la intervención de terceros de confianza. Sin embargo, la llegada de la tecnología blockchain promete revolucionar este campo, ofreciendo nuevas capas de seguridad y eficiencia. En este artículo, exploramos cómo la cadena de bloques está transformando la seguridad jurídica y qué significa esto para el futuro de la certificación de documentos.

## ¿Qué es Blockchain y por qué es relevante para la certificación?

La blockchain, o cadena de bloques, es esencialmente un registro digital descentralizado y distribuido. A diferencia de las bases de datos tradicionales, que son controladas por una única entidad, la blockchain opera en una red de computadoras, donde cada transacción es verificada y registrada de forma inmutable. Esta inmutabilidad es clave para la certificación de documentos, ya que garantiza que una vez que un registro es creado, no puede ser alterado ni borrado sin el consenso de la red.

## Seguridad Jurídica en la Era Digital

La seguridad jurídica es fundamental para el funcionamiento de cualquier sociedad. Garantiza la previsibilidad y la confianza en las transacciones legales. Con la digitalización, han surgido nuevos desafíos, como la falsificación de documentos electrónicos y la manipulación de datos. La tecnología blockchain ofrece una solución robusta a estos problemas.

Al utilizar la blockchain para la certificación, se crea un registro timestamped (con marca de tiempo) y único de un documento. Este registro sirve como prueba irrefutable de su existencia y contenido en un momento dado. Esto es particularmente útil para contratos, títulos de propiedad, testamentos y otros documentos legales críticos.

*"La tecnología blockchain no viene a reemplazar la función notarial, sino a potenciarla. Al integrar registros inmutables y distribuidos, podemos ofrecer a nuestros clientes una capa adicional de certeza jurídica en sus transacciones digitales, asegurando la integridad de la información de manera sin precedentes."* — Ricardo Dehesa Cortés.

## El Futuro de la Certificación de Documentos

El futuro de la certificación de documentos está indudablemente ligado a la adopción de tecnologías avanzadas como la blockchain. A medida que las regulaciones evolucionan para reconocer la validez legal de estos registros, veremos una mayor integración de la cadena de bloques en los procesos notariales y legales. Esto no solo aumentará la seguridad, sino que también agilizará los trámites y reducirá costos.

## Notaría Pública 90: Innovación y Confianza a su Servicio

En la Notaría Pública 90, estamos a la vanguardia de la tecnología para garantizar la máxima seguridad y eficiencia en todos sus trámites legales. Nuestro compromiso con la innovación nos permite ofrecer soluciones modernas, adaptándonos a las necesidades del mundo digital. Visítenos y descubra cómo podemos ayudarle a certificar sus documentos con total confianza y respaldo legal.

¡Contáctenos hoy mismo y asegure su tranquilidad jurídica!
`
  },
  'hitchain-y-notaria-90-nuevo-estandar-seguridad-juridica-digital': {
    slug: 'hitchain-y-notaria-90-nuevo-estandar-seguridad-juridica-digital',
    title: 'Hitchain y Notaría Pública 90 de Playa del Carmen: El Nuevo Estándar de la Seguridad Jurídica Digital',
    date: 'mayo 5, 2026',
    category: 'Legaltech & Blockchain',
    author: 'Daniel Sánchez Pérez',
    authorTitle: 'Director de TI - Notaría Pública 90',
    excerpt: 'La alianza entre Hitchain y la Notaría Pública 90 de Playa del Carmen demuestra que la fe pública y la tecnología de vanguardia juntas crean un blindaje jurídico sin precedentes.',
    content: `
En la era de la inmediatez, el derecho tradicional se enfrenta a su mayor desafío: evolucionar sin perder la certeza. En México, esta transformación ha encontrado su punto de inflexión en la alianza entre <a href="https://hitchain.com.mx" class="text-notaria-secondary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">Hitchain</a>, el ecosistema digital que aloja la aplicación Hitch, y la <a href="https://notariapublica90.com" class="text-notaria-secondary font-semibold hover:underline">Notaría Pública 90</a> de Quintana Roo, con sede en Playa del Carmen. Bajo la dirección del Ricardo Dehesa Cortés, esta colaboración está demostrando que la fe pública y la tecnología de vanguardia no solo son compatibles, sino que juntas crean un entorno de blindaje jurídico sin precedentes.

## 1. El Ecosistema Hitchain: Más allá de una Aplicación

Hitchain no es simplemente un nombre de dominio; es la infraestructura que da vida a Hitch. Como se detalla en su <a href="https://hitchain.com.mx/whitepaper" class="text-notaria-secondary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">documento técnico</a>, Hitchain opera como un protocolo de "Legalidad como Servicio" (LaaS). A través de su aplicación, los usuarios pueden gestionar contratos, validar identidades y formalizar acuerdos con un nivel de seguridad que el papel físico no puede igualar.

Hitchain actúa como el motor que permite la tokenización de documentos legales, convirtiendo cada contrato en un activo digital único e inalterable. Esta plataforma se posiciona como la verdadera puerta de entrada a la legalidad digital, permitiendo que empresas y ciudadanos operen con agilidad en un mundo globalizado.

## 2. La Notaría 90: Vanguardia en el Corazón de la Riviera Maya

Si la tecnología es el vehículo, la Notaría Pública 90 es la autoridad que otorga el permiso de circulación. Ubicada estratégicamente en Playa del Carmen, esta notaría se ha consolidado como líder en la adopción de herramientas digitales a través de su portal oficial: notariapublica90.com. El liderazgo de Ricardo Dehesa Cortés ha sido clave para integrar la fe pública con la innovación, asegurando que cada trámite cuente con el respaldo de la ley y la eficiencia del bit.

### El Rol del Notario en la Era Digital

Para Dehesa Cortés, el papel del notario en un polo de inversión como Playa del Carmen ha cambiado. Ya no se trata solo de ser un custodio de protocolos, sino un facilitador de seguridad en entornos complejos. El titular de la Notaría 90 afirma:

*"La seguridad jurídica no puede ser un freno para el desarrollo; debe ser su motor. Nuestra integración con Hitchain nos permite ofrecer a los clientes la rapidez que demandan los negocios modernos sin sacrificar ni un ápice de la certeza legal que solo un Notario puede brindar."*

## 3. ¿Cómo funciona la sinergia Hitchain - Notaría 90?

El funcionamiento de este ecosistema es un proceso fluido que combina biometría, criptografía y derecho notarial. Aquí se detalla el flujo de esta operación:

- **Gestión desde el Portal y la App:** Todo comienza en la aplicación alojada en el ecosistema Hitchain o mediante el contacto directo en el portal de la Notaría 90. El usuario carga el documento o utiliza las plantillas inteligentes de la app. El sistema realiza una validación biométrica avanzada, comparando la identidad del firmante contra bases de datos oficiales.
- **El Proceso de Tokenización:** Una vez que las partes han firmado electrónicamente, el protocolo de Hitchain entra en acción. El documento se registra en una cadena de bloques (blockchain), creando una "doble certificación": la del sistema tecnológico y la que vendrá posteriormente del notario.
- **La Intervención de la Notaría 90 en Playa del Carmen:** La intervención de la Notaría 90 eleva el documento a un nivel de prueba plena. El Ricardo Dehesa Cortés supervisa la legalidad del acto, asegura que no existan vicios en la voluntad y procede a dar fe pública, asentando el acto en el protocolo correspondiente con el respaldo de la infraestructura digital.

*"Al utilizar Hitchain, no solo estamos digitalizando un proceso, estamos creando un registro histórico inmutable de la voluntad humana"* — Ricardo Dehesa Cortés

## 4. Apartado Técnico: Auditoría y Blockchain en la Función Notarial

Uno de los mayores avances de la Notaría 90 es la implementación de procesos de auditoría basados en el registro de Hitchain. A diferencia de los archivos tradicionales, donde la verificación de un documento puede requerir días de búsqueda física, el protocolo blockchain permite una validación instantánea y matemática.

Cada vez que la Notaría 90 certifica un acto a través de Hitchain, se genera un registro con un sello de tiempo (Timestamp) y una huella digital (Hash). Esta capacidad técnica permite que la Notaría 90 ofrezca servicios de auditoría preventiva, donde las empresas pueden verificar la integridad de toda su cadena de contratos de manera automatizada.

## 5. El Impacto en Playa del Carmen y Quintana Roo

Playa del Carmen es un epicentro de transacciones inmobiliarias internacionales. En este escenario, la Notaría 90 ha sido pionera en usar estas herramientas para proteger la inversión. A través de notariapublica90.com, los usuarios pueden acceder a servicios de alta especialidad:

- Fideicomisos y transmisiones de propiedad.
- Constitución de sociedades mercantiles.
- Ratificación de firmas y fe de hechos.

Ricardo Dehesa Cortés destaca:

*"Quintana Roo es la ventana de México al mundo. Para mantener la confianza de los inversionistas en Playa del Carmen, debemos ofrecer herramientas de clase mundial. Hitchain nos permite hablar el mismo idioma que los fondos de inversión globales."*

## 6. El Futuro es la Legalidad Digital

La alianza entre Hitchain y la Notaría Pública 90 de Playa del Carmen marca el camino para el resto del notariado mexicano. El uso de la tecnología bajo el protocolo de Hitchain representa la madurez de la tecnología legal (LegalTech). Como bien ha impulsado el Ricardo Dehesa Cortés, la fe pública no debe residir en el papel, sino en la verdad de los actos. Con esta tecnología, esa verdad queda grabada de forma permanente en la red, protegida por la ley y certificada por un notario de vanguardia en la Riviera Maya.

## 7. Conclusión: Una Invitación al Futuro de la Certeza

La transformación que hoy lidera la Notaría Pública 90 de Playa del Carmen no es un circuito cerrado; es, en esencia, un nuevo estándar disponible para todo el ecosistema legal y financiero de México. La infraestructura de Hitchain ha demostrado que la tecnología no es una amenaza para la fe pública, sino su mayor aliada para garantizar la transparencia en un mundo globalizado.

Este modelo de "doble certificación" —legal y tecnológica— es el eslabón que faltaba para conectar la voluntad de las partes con una seguridad inquebrantable. Hoy, el llamado es a la colaboración y a la adopción proactiva de estas herramientas para fortalecer el Estado de Derecho.

El Ricardo Dehesa Cortés extiende una invitación abierta a los actores clave del desarrollo nacional:

*"Hitchain no es solo una plataforma para nuestra notaría; es una infraestructura de confianza ya creada y lista para ser aprovechada. Invito a mis colegas notarios, a los gobiernos, a las instituciones bancarias y a las empresas a sumarse a esta evolución. El objetivo es común: dotar a cada contrato y a cada acto jurídico de una capa de seguridad inmutable, trazable y transparente. El futuro de la certeza legal ya está aquí, y es responsabilidad de todos nosotros utilizarlo para blindar el patrimonio y la confianza de los ciudadanos."*

La sinergia entre la experiencia notarial tradicional y la potencia del ecosistema digital marca el inicio de una era donde la legalidad no solo se firma, sino que se blinda para la eternidad.
`
  },
  'la-era-de-la-notaria-4': {
    slug: 'la-era-de-la-notaria-4',
    title: 'La Era de la Notaría 4.0: Blockchain y Certeza Jurídica en Quintana Roo',
    date: 'abril 9, 2026',
    category: 'Tecnología Legal',
    author: 'Ricardo Dehesa Cortés',
    authorTitle: 'Notario Titular - Notaría Pública 90',
    excerpt: 'En un mundo donde la digitalización avanza a pasos agigantados, la fe pública no puede quedarse atrás. La Notaría Pública 90 se consolida como un referente de innovación al integrar herramientas tecnológicas de vanguardia.',
    content: `
En un mundo donde la digitalización avanza a pasos agigantados, la fe pública no puede quedarse atrás. La <a href="https://notariapublica90.com" class="text-notaria-secondary font-semibold hover:underline">Notaría Pública 90</a>, ubicada en el corazón de Playa del Carmen, se ha consolidado como un referente de innovación al integrar herramientas tecnológicas de vanguardia para proteger el patrimonio de sus clientes.

## Una visión liderada por la experiencia

Para el Ricardo Dehesa Cortés, Notario Titular de la Notaría 90, la seguridad jurídica no es un concepto estático, sino una responsabilidad que debe evolucionar con los tiempos. Con una trayectoria destacada en el derecho inmobiliario de la Riviera Maya, el Licenciado ha impulsado la transición hacia lo que se denomina la "Notaría 4.0".

*"La tecnología no viene a sustituir la fe pública, sino a blindarla. Nuestro compromiso es garantizar que cada documento y cada voluntad cuente con capas de seguridad que antes eran inimaginables"* — Ricardo Dehesa Cortés

## HITCH: El escudo digital para tu propiedad

El pilar de esta transformación es la implementación de <a href="https://hitchain.io" class="text-notaria-secondary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">HITCH</a>, un ecosistema diseñado para ofrecer certeza jurídica total a través de la tecnología Blockchain.

A diferencia de los métodos tradicionales, la integración con la plataforma de HITCH permite:

- **Trazabilidad Notarial:** Cada acto jurídico genera un registro inmutable que se conecta en bloques, haciendo imposible cualquier alteración posterior del documento.
- **Monitoreo en Tiempo Real:** Los usuarios pueden recibir notificaciones sobre cualquier movimiento relacionado con su patrimonio.
- **Seguridad Activa:** Mediante el uso de protocolos avanzados, se eliminan los riesgos de suplantación de identidad en transacciones de alto valor.

## ¿Por qué elegir la Notaría 90?

Bajo un esquema de <a href="/gobierno-corporativo" class="text-notaria-secondary font-semibold hover:underline">Gobierno Corporativo</a> y la dirección estratégica de Ricardo Dehesa Cortés, la Notaría 90 no solo ofrece los servicios tradicionales de escrituración, testamentos y actas constitutivas, sino que se posiciona como una central de soluciones tecnológicas.

Al utilizar herramientas como HITCH, la Notaría 90 garantiza que los inversionistas cuenten con un respaldo digital que trasciende el papel, asegurando su inversión en una de las zonas de mayor plusvalía del mundo.

## Certeza Legal en la Era Digital

¿Tienes dudas sobre tu proceso? Consulta a nuestro <strong>asistente virtual</strong> y <a href="/contacto" class="text-notaria-secondary font-semibold hover:underline">contáctanos</a> o visítanos en el Edificio Tan-Ik, Playa del Carmen, Quintana Roo.

La Notaría 90 está certificada bajo la norma <a href="/iso" class="text-notaria-secondary font-semibold hover:underline">ISO 9001:2015</a>, garantizando los más altos estándares de calidad en todos nuestros servicios notariales.
    `
  },
  
  'hitch-la-puerta-de-entrada-a-la-legalidad-digital': {
    slug: 'hitch-la-puerta-de-entrada-a-la-legalidad-digital',
    title: 'HITCH, la puerta de entrada a la legalidad digital',
    date: 'noviembre 28, 2025',
    category: 'Tecnología Legal',
    image: 'https://images.unsplash.com/photo-1769092992534-f2d0210162b9?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1769092992534-f2d0210162b9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Desde el corazón del Caribe mexicano, una nueva visión del derecho está redefiniendo los cimientos de la legalidad y la confianza en la era digital',
    content: `
Desde el corazón del Caribe mexicano, una nueva visión del derecho está redefiniendo los cimientos de la legalidad y la confianza en la era digital. Ricardo Dehesa, notario titular de la Notaría Pública 90, y Alan Santana, socio fundador del Grupo BINKIO, encabezan un modelo pionero que fusiona blockchain, fe pública y trazabilidad jurídica. En entrevista, ambos especialistas despejan las dudas del aire sobre el mundo legal y tecnológico que estamos viviendo.

**Ricardo, usted habla de una "nueva columna vertebral para la economía de la verdad". ¿Cómo define ese concepto en el contexto jurídico actual?**

**Ricardo Dehesa:** Durante años, los sistemas legales han operado sobre la base de la confianza humana, reforzada por estructuras burocráticas. Lo que proponemos es amplificar esa confianza con tecnología. La economía de la verdad es aquella donde los hechos jurídicos pueden verificarse, auditarse y certificarse sin ambigüedades, con evidencia criptográfica. Ya no se trata sólo de confiar: se trata de verificar.

**Muchos temen que la blockchain sustituya al notariado. ¿Qué opina?**

**R.D.:** Todo lo contrario. La blockchain no reemplaza la figura del notario; la eleva. Nosotros no renunciamos al juicio humano, sino que lo fortalecemos con sistemas que aseguran que cada firma, cada contrato y cada registro deje una huella inalterable. Es una simbiosis entre lo legal y lo tecnológico.

**En la práctica, ¿cuáles son los beneficios de integrar blockchain al trabajo notarial?**

**R.D.:** Hoy, aunque los registros oficiales aún no están plenamente integrados con blockchain, HITCH cumple una función fundamental como capa de protección documental. Al operar como un sistema de encriptación avanzada, HITCH garantiza que cada documento generado, firmado o validado quede protegido contra duplicación, alteración o fraude.

**¿Cómo opera HITCH en la práctica y cómo pueden integrarse otros notarios, gobiernos o profesionales legales?**

**R.D.:** HITCH funciona como una plataforma donde el notario puede cargar, validar y encriptar documentos jurídicos. Cada archivo genera un hash único que se registra en la blockchain, asegurando que no pueda ser alterado ni duplicado. Esta estructura puede ser adoptada fácilmente por otros notarios, gobiernos, municipios, empresariado privado o despachos legales.

**¿Y cómo se comunica esto al consumidor final? ¿Cómo entiende que su escritura vale más gracias a esta tecnología?**

**R.D.:** Para quien recibe una escritura o contrato, HITCH actúa como una capa invisible pero poderosa. A simple vista es un documento normal, pero al escanear un código QR o usar una clave digital, puede comprobar su autenticidad, fecha de creación, y verificar que no ha sido modificado. Eso le da valor probatorio inmediato. Le estamos dando al ciudadano una escritura que no sólo es legal, sino también inmutable, verificable y respaldada por una red descentralizada.

![HITCH Image](https://raycalzada.com/notaria90/wp-content/uploads/2025/11/image-1024x1024.png)

**¿Cuál es la estrategia para trascender las fronteras de México y llevar este modelo a otros países o colegios notariales?**

**R.D.:** Nuestra estrategia es clara: colaboración internacional con impacto local. Hemos documentado el modelo de HITCH, desarrollado una metodología replicable y estamos en conversaciones con colegios notariales, universidades de derecho, gobiernos y actores de la industria. Buscamos que HITCH no sea solo una solución mexicana, sino que forme parte de la red global del notariado. En ese sentido, aspiramos a sumarnos activamente a la Unión Internacional del Notariado (UINL), que agrupa a más de 92 notariados nacionales en todo el mundo, para posicionar nuestro modelo dentro del sistema global de estándares notariales.

**¿Qué rol ocupa el notario en esta nueva era de confianza digital, y cómo pueden integrarse otros actores institucionales al modelo que usted impulsa?**

**R.D.:** Esta tecnología transforma al notario en un agente de confianza digital, fortaleciendo su rol con criptografía y trazabilidad. HITCH no lo reemplaza, lo potencia. El modelo contempla una adopción progresiva para notarios, gobiernos y municipios, con protocolos claros y una arquitectura interoperable. Es una infraestructura legal compartida, lista para escalar y elevar los estándares jurídicos en cualquier jurisdicción.

**El fraude documental y la suplantación de identidad han sido problemas crónicos. ¿Cómo los abordan desde HITCH?**

**R.D.:** La prevención del fraude y la suplantación de identidad es un pilar de HITCH. Cada documento se encripta y registra con una huella digital única, lo que impide su duplicación o manipulación. Este proceso genera trazabilidad total y convierte cada acto jurídico en una pieza verificable con respaldo técnico y legal, elevando el estándar de seguridad para ciudadanos, empresas y autoridades.

**En términos de inversión y escalabilidad, ¿BINKIO y HITCH están buscando capital o alianzas institucionales?**

**R.D.:** Absolutamente. Este modelo está hecho para escalar regional e internacionalmente. Buscamos alianzas con bancos, aseguradoras, gobiernos e inversores institucionales que comprendan el valor de una infraestructura de confianza jurídica digital. Nuestra meta es clara: conectar los registros de propiedad a la blockchain.

## Alan Santana y la creación de Grupo BINKIO

Alan Santana, abogado de formación e inversionista en Bitcoin desde 2017, es el arquitecto tecnológico detrás de BINKIO. Con trayectoria en identidad digital, tokenización y trazabilidad, identificó desde el inicio la necesidad de construir una infraestructura financiera jurídicamente viable para el ecosistema descentralizado.

**Alan, ¿cuál fue el momento en que entendiste que el ecosistema blockchain necesitaba una infraestructura como BINKIO?**

**Alan Santana:** Fue en 2017, cuando empecé a estudiar el movimiento de capitales para la compra de propiedades a través de activos virtuales. Había entusiasmo, pero ninguna garantía legal. Ahí comprendí que sin puentes con la legalidad, todo quedaba en la informalidad. BINKIO nace para resolver eso: darle marco jurídico a la innovación.

**Ahora que ya han validado los modelos en campo, ¿cuál es la siguiente prioridad? ¿Qué buscan escalar?**

**A.S.:** Nuestro objetivo es que las instituciones públicas y las empresas integren BINKIO y HITCH como parte natural de su operación diaria. No ofrecemos un software más, sino una nueva cultura de legalidad digital. Buscamos que cada actor del sistema comprenda que operar con confianza no es una aspiración, sino un protocolo ejecutable.

## El Salvador, la LEAD y la infraestructura legal para tokenizar

**A.S.:** BINKIO obtuvo la licencia de emisor de activos digitales bajo la LEAD. Esta licencia nos permite emitir tokens representativos de documentos legales, propiedades, instrumentos financieros o derechos económicos, todo con respaldo jurídico. Esto no es especulación: es una tokenización con estructura legal. Además, gracias a la compatibilidad legal entre México y El Salvador, podemos articular operaciones binacionales de forma transparente.

## Participación institucional y foros de adopción

BINKIO y HITCH han tenido presencia activa en eventos internacionales clave como Bitcoin Histórico en El Salvador y el Foro Blockchain en Querétaro, México. Estos foros no solo funcionan como vitrinas estratégicas para exponer la propuesta de valor del modelo legal-tecnológico, sino que también permiten alinear la narrativa con las tendencias más relevantes del ecosistema: Web3, identidad soberana, tokenización de activos reales (RWA) y la nueva generación de infraestructura pública digital.
    `
  },
  
  'notificacion-notarial': {
    slug: 'notificacion-notarial',
    title: 'NOTIFICACION NOTARIAL',
    date: 'noviembre 28, 2025',
    category: 'Tips Legales',
    image: 'https://notariapublica90.com/wp-content/uploads/2025/11/notificacion-notarial-225x300.jpg',
    featuredImage: 'https://notariapublica90.com/wp-content/uploads/elementor/thumbs/notificacion-notarial-rfcnck0vhk55scizd7goxog5mjhqgd3wjlfnd0v4xk.jpg',
    excerpt: 'Este mecanismo, respaldado por la Ley del Notariado, permite comunicar formalmente hechos y decisiones con valor probatorio y presunción de veracidad.',
    content: `
En el ámbito jurídico, la certeza y formalidad son elementos fundamentales para la protección de derechos y el cumplimiento de obligaciones. En este sentido, las **Notificaciones Notariales** constituyen un mecanismo eficaz y formal para hacer del conocimiento de una persona determinados hechos o manifestaciones de voluntad con **valor probatorio** y **eficacia legal**. En el Estado de **Quintana Roo**, este procedimiento tiene respaldo normativo, utilidad práctica y significativa en cualquier acto o hecho jurídico, que cualquier particular con interés legal solicite.

## ¿Qué es una Notificación Notarial?

La notificación notarial es el **acto por el cual un Notario Público**, a solicitud de una parte interesada, **hace entrega formal de un documento o comunicación a un destinatario**, dejando constancia fehaciente de la entrega, el contenido notificado, la identidad del receptor, así como de las circunstancias de modo, tiempo y lugar en que ocurrió el acto.

Este procedimiento se encuentra regulado por la **Ley del Notariado para el Estado de Quintana Roo**, la cual faculta al notario para realizar diligencias de notificación y dejar constancia de las mismas en instrumento público o acta circunstanciada.

## Fundamento Legal en Quintana Roo

La **Ley del Notariado para el Estado de Quintana Roo**, en su artículo 109, fracción I, establece que es función del notario:

*"I.-Notificaciones, interpelaciones, requerimientos, protesto de documentos mercantiles y otras diligencias en las que pueda intervenir el Notario según las leyes"*

Asimismo, el **Reglamento del Notariado** y los **usos Notariales** complementan este marco legal, otorgando al notario la autoridad para llevar a cabo estas diligencias de manera imparcial, objetiva y con total apego a la legalidad.

## ¿Qué valor tiene una Notificación Notarial?

A diferencia de una notificación realizada por medios privados o electrónicos sin control legal, la notificación notarial:

- **Da fe pública** del acto de notificación.
- Tiene **presunción de veracidad**, al ser realizada por un fedatario público.
- Puede ser usada como **medio de prueba en juicio**.
- Reduce el riesgo de controversias respecto al momento y forma en que se entregó determinada comunicación.

## Aplicaciones Comunes

En Quintana Roo, las notificaciones notariales se utilizan frecuentemente en:

- Requerimientos de pago extrajudicial.
- Notificación de rescisión de contratos.
- Avisos de desocupación de inmuebles.
- Notificación de cesión de derechos.
- Informes previos a acciones legales.
- Comunicación de acuerdos societarios o decisiones corporativas.

## Procedimiento General

1. **Solicitud formal** del interesado al notario, acompañada del escrito a notificar.
2. **Revisión y aceptación** por parte del notario.
3. **Diligencia personal** en el domicilio señalado, levantando acta de los hechos.
4. En caso de **negativa o ausencia**, el notario asienta los detalles en el acta, pudiendo dejar copia en el domicilio conforme a derecho.
5. **Protocolo o archivo** del acta notarial, entregando el respectivo testimonio Notarial a quien la solicite.

## Consideraciones Finales

Las notificaciones notariales en Quintana Roo son un instrumento jurídico confiable, ágil y preventivo, que puede evitar litigios prolongados y servir como base probatoria sólida con el respaldo de la fe pública. En operaciones civiles, mercantiles o incluso familiares, su correcta utilización representa un paso clave hacia la seguridad jurídica.
    `
  },
  
  'constitucion-regimen-propiedad': {
    slug: 'constitucion-regimen-propiedad',
    title: 'Tip del notario: constitución de régimen de propiedad en condominio en Quintana Roo',
    date: 'noviembre 28, 2025',
    category: 'Derecho Inmobiliario',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    image: 'https://images.unsplash.com/photo-1759429255330-51145b170dad?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1759429255330-51145b170dad?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'El Régimen de Propiedad en Condominio exige un proceso notarial que garantiza seguridad jurídica, define derechos y facilita la administración de los desarrollos inmobiliarios.',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Constitución de Régimen de Propiedad en Condominio en Quintana Roo

El **Régimen de Propiedad en Condominio** es una figura jurídica que permite la propiedad y uso compartido de inmuebles, especialmente relevante en el desarrollo inmobiliario de Quintana Roo, particularmente en zonas turísticas como Playa del Carmen, Cancún y Tulum.

## Marco Legal

Este régimen se encuentra regulado por:

- **Código Civil del Estado de Quintana Roo** (Artículos 1001 al 1036)
- **Ley del Notariado para el Estado de Quintana Roo**
- **Reglamento de Construcción del Municipio correspondiente**

## ¿Qué es el Régimen de Condominio?

Es una modalidad de propiedad donde coexisten:

- **Áreas privativas:** Departamentos, locales o unidades de uso exclusivo
- **Áreas comunes:** Terreno, estructura, instalaciones generales, amenidades

Cada condómino es propietario exclusivo de su unidad privativa y copropietario proporcional de las áreas comunes.

## Proceso Notarial de Constitución

1. **Documentación del Inmueble**
   - Título de propiedad del terreno
   - Certificado de libertad de gravamen
   - Licencia de construcción
   - Planos arquitectónicos autorizados

2. **Elaboración del Proyecto de Escritura**
   - Descripción técnica del inmueble
   - Delimitación de áreas privativas y comunes
   - Determinación de indivisos
   - Reglamento del Condominio

3. **Otorgamiento ante Notario Público**
   - Comparecencia del propietario o desarrollador
   - Lectura y firma de la escritura constitutiva
   - Fe pública del acto jurídico

4. **Inscripción en el Registro Público**
   - Presentación en el Registro Público de la Propiedad
   - Anotación preventiva
   - Inscripción definitiva

## Elementos Esenciales del Reglamento

El Reglamento del Condominio debe contener:

- Descripción del inmueble y sus unidades
- Determinación del valor de cada unidad
- Porcentaje de indivisos
- Normas de convivencia
- Obligaciones de los condóminos
- Régimen de administración
- Cuotas de mantenimiento

## Ventajas del Régimen de Condominio

- **Seguridad Jurídica:** Cada unidad puede ser comprada, vendida o hipotecada independientemente
- **Orden Administrativo:** Reglas claras de convivencia y mantenimiento
- **Plusvalía:** Mayor atractivo para inversionistas
- **Financiamiento:** Acceso a créditos hipotecarios individuales

## Importancia en Quintana Roo

En el contexto del desarrollo inmobiliario de la Riviera Maya, el régimen de condominio facilita:

- Proyectos turísticos y residenciales
- Inversión extranjera legal y transparente
- Administración eficiente de desarrollos verticales
- Protección patrimonial de propietarios

## Recomendaciones

- Verificar que el desarrollador tenga título de propiedad legítimo
- Revisar cuidadosamente el reglamento del condominio
- Confirmar que la obra esté autorizada por las autoridades competentes
- Asesorarse con un notario de confianza desde el inicio del proceso

En la **Notaría Pública 90** contamos con experiencia especializada en la constitución de regímenes de condominio en Quintana Roo, garantizando certeza jurídica en cada etapa del proceso.
    `
  },

  'ratificacion-notarial': {
    slug: 'ratificacion-notarial',
    title: 'Ratificación notarial: la clave legal que da vida a actos jurídicos incompletos',
    date: 'noviembre 28, 2025',
    category: 'Derecho Notarial',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    image: 'https://images.unsplash.com/photo-1578531506902-49f183f11ea2?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1578531506902-49f183f11ea2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Este mecanismo permite otorgar validez a documentos o actos que originalmente carecían de requisitos esenciales; el notario garantiza certeza jurídica y evita futuros conflictos.',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Ratificación Notarial: La Clave Legal que da Vida a Actos Jurídicos Incompletos

La **ratificación notarial** es un acto jurídico mediante el cual una persona confirma ante notario público la validez y contenido de un documento o acto que originalmente carecía de algún requisito de forma o solemnidad exigido por la ley.

## ¿Qué es la Ratificación Notarial?

Es el acto por el cual los otorgantes de un documento privado comparecen ante notario público para:

- **Reconocer** como suya la firma plasmada en el documento
- **Confirmar** el contenido y alcance del acto jurídico
- **Otorgar validez legal** mediante la fe pública notarial

## Marco Legal

La ratificación notarial se sustenta en:

- **Código Civil del Estado de Quintana Roo**
- **Ley del Notariado para el Estado de Quintana Roo** (Artículo 109)
- **Código de Procedimientos Civiles**

## Casos Comunes de Ratificación

### 1. Contratos Privados
Contratos de compraventa, arrendamiento o prestación de servicios que requieren elevarse a escritura pública o adquirir mayor certeza jurídica.

### 2. Poderes
Documentos que otorgan representación legal pero que fueron firmados de manera privada y requieren formalización notarial.

### 3. Actas de Asamblea
Acuerdos societarios o condominales que necesitan validación ante fedatario público.

### 4. Convenios
Acuerdos entre partes que requieren fuerza probatoria para efectos legales o registrales.

## Procedimiento de Ratificación

1. **Solicitud**
   - Los interesados acuden al notario con el documento a ratificar
   - Presentan identificación oficial vigente

2. **Verificación**
   - El notario revisa el contenido del documento
   - Confirma la capacidad legal de los comparecientes
   - Verifica que no contravenga disposiciones legales

3. **Comparecencia**
   - Las partes comparecen personalmente ante el notario
   - Manifiestan que reconocen su firma y el contenido del documento
   - Confirman su voluntad de obligarse

4. **Acta Notarial**
   - El notario levanta acta circunstanciada
   - Asienta las manifestaciones de los comparecientes
   - Da fe pública del acto

5. **Protocolo**
   - El acta se integra al protocolo notarial
   - Se expiden testimonios a las partes interesadas

## Efectos Legales

La ratificación notarial produce los siguientes efectos:

- **Fe pública:** El documento adquiere presunción de veracidad
- **Fecha cierta:** Se establece una fecha indubitable del acto
- **Fuerza probatoria:** Mayor valor como medio de prueba en juicio
- **Ejecutividad:** En algunos casos, permite la ejecución del documento

## Diferencia con la Protocolización

- **Ratificación:** Se reconoce la firma y contenido de un documento privado
- **Protocolización:** Se incorpora al protocolo notarial un documento completo (público o privado) para su conservación

## Ventajas de la Ratificación Notarial

- Otorga **certeza jurídica** a actos privados
- Evita **controversias futuras** sobre la autenticidad del documento
- Facilita el **reconocimiento** del documento ante autoridades
- Permite la **inscripción registral** cuando es requerida
- Protege los **derechos** de las partes involucradas

## Costos y Tiempos

El costo de la ratificación notarial depende de:
- Valor del acto o documento
- Número de comparecientes
- Complejidad del asunto

El tiempo de elaboración es generalmente de 3 a 5 días hábiles.

## Recomendaciones

- Acudir con el **documento original**
- Que **todas las partes** comparezcan personalmente
- Llevar **identificación oficial vigente**
- Asegurarse de que el contenido del documento sea **claro y completo**
- Consultar con el notario sobre la **procedencia** de la ratificación

En la **Notaría Pública 90**, brindamos asesoría especializada en ratificaciones notariales, garantizando la seguridad jurídica que tu patrimonio requiere.
    `
  },

  'medios-solucion-controversias': {
    slug: 'medios-solucion-controversias',
    title: 'Tip del Notario: Medios de solución de controversias',
    date: 'junio 15, 2025',
    category: 'Derecho Procesal',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    image: 'https://images.unsplash.com/photo-1767972463877-b64ba4283cd0?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1767972463877-b64ba4283cd0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Las controversias por regla general se deben de resolver ante los tribunales establecidos por el Estado, sin embargo, existen otros medios de solución de controversias.',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Medios de Solución de Controversias

Las controversias legales pueden resolverse de diferentes maneras. Si bien la vía jurisdiccional (tribunales) es la más conocida, existen **medios alternativos** que ofrecen ventajas significativas en términos de tiempo, costo y confidencialidad.

## Vías de Solución de Conflictos

### 1. Vía Jurisdiccional

**Litigio ante Tribunales:**
- Proceso formal ante juzgados y tribunales
- Intervención de un juez que dicta sentencia
- Regido por códigos procesales
- Proceso público y formal

**Características:**
- **Tiempo:** Puede extenderse por años
- **Costo:** Honorarios de abogados, costas procesales
- **Resultado:** Sentencia obligatoria y ejecutable
- **Apelación:** Posibilidad de recursos

### 2. Medios Alternativos de Solución de Controversias (MASC)

## A. Mediación

Proceso en el cual un **tercero neutral** (mediador) facilita la comunicación entre las partes para que lleguen a un acuerdo voluntario.

**Características:**
- **Voluntario:** Las partes deciden si aceptan el acuerdo
- **Confidencial:** Lo tratado no se hace público
- **Flexible:** Las partes proponen sus propias soluciones
- **Mediador:** No impone decisiones, solo facilita el diálogo

**Ventajas:**
- Rapidez (días o semanas)
- Menor costo
- Preserva las relaciones entre las partes
- Control sobre el resultado

**Ámbitos de aplicación:**
- Conflictos familiares
- Disputas comerciales
- Controversias laborales
- Asuntos vecinales

## B. Conciliación

Similar a la mediación, pero el conciliador puede **proponer soluciones** a las partes.

**Características:**
- El conciliador tiene un rol más activo
- Puede sugerir alternativas de solución
- El acuerdo es voluntario
- Proceso confidencial

**Ventajas:**
- Orientación profesional
- Soluciones creativas
- Mayor probabilidad de acuerdo
- Menor desgaste emocional

## C. Arbitraje

Las partes someten su controversia a uno o varios **árbitros** que dictan un **laudo arbitral** (equivalente a sentencia).

**Tipos de Arbitraje:**

1. **Arbitraje de Derecho:** El árbitro aplica estrictamente la ley
2. **Arbitraje de Equidad:** El árbitro decide conforme a su leal saber y entender

**Características:**
- **Laudo arbitral:** Obligatorio y ejecutable
- **Más rápido** que un juicio ordinario
- **Especialización:** Los árbitros suelen ser expertos en la materia
- **Confidencialidad:** El proceso y el laudo son privados

**Ventajas:**
- Especialización técnica de los árbitros
- Menor tiempo que un juicio
- Flexibilidad procesal
- Confidencialidad del proceso

**Desventajas:**
- Costo de honorarios del árbitro
- Limitaciones en recursos de impugnación
- Requiere acuerdo previo (cláusula arbitral)

## D. Negociación Directa

Las partes dialogan directamente sin intervención de terceros.

**Características:**
- Comunicación directa entre las partes
- Sin formalidades
- Resultado: acuerdo voluntario

**Recomendable cuando:**
- Las partes mantienen buena comunicación
- El conflicto no es complejo
- Existe voluntad de llegar a un acuerdo

## Comparativa de Métodos

| Método | Tiempo | Costo | Formalidad | Resultado |
|--------|--------|-------|------------|-----------|
| Juicio | Años | Alto | Alta | Sentencia obligatoria |
| Mediación | Semanas/Meses | Bajo | Baja | Acuerdo voluntario |
| Conciliación | Semanas/Meses | Bajo-Medio | Media | Acuerdo voluntario |
| Arbitraje | Meses | Medio-Alto | Media-Alta | Laudo obligatorio |
| Negociación | Días/Semanas | Muy bajo | Muy baja | Acuerdo voluntario |

## El Notario como Medio Preventivo

El **Notario Público** desempeña un rol fundamental en la **prevención de controversias** mediante:

- **Asesoría jurídica** imparcial
- **Formalización** adecuada de actos jurídicos
- **Fe pública** que otorga certeza
- **Prevención** de vicios en contratos

## Recomendaciones

1. **Evalúa la naturaleza del conflicto** antes de elegir el método
2. **Considera el tiempo** que estás dispuesto a invertir
3. **Analiza los costos** de cada alternativa
4. **Prioriza la preservación** de relaciones cuando sea relevante
5. **Asesórate** con profesionales del derecho

En la **Notaría Pública 90**, te orientamos sobre la mejor vía para resolver tus controversias y, cuando es posible, facilitamos acuerdos que eviten litigios innecesarios.
    `
  },

  'sucesion-testamentaria': {
    slug: 'sucesion-testamentaria',
    title: 'Tip del Notario: Sucesión testamentaria',
    date: 'junio 15, 2025',
    category: 'Derecho Sucesorio',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    image: 'https://images.unsplash.com/photo-1767972159674-460283907c21?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1767972159674-460283907c21?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Es aquel acto jurídico por el cual un sujeto denominado testador, voluntariamente, dispone de sus bienes para que después de su muerte sean transferidos.',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Sucesión Testamentaria

La **sucesión testamentaria** es el proceso mediante el cual se transmiten los bienes, derechos y obligaciones de una persona fallecida a sus herederos, conforme a la voluntad expresada en un **testamento**.

## ¿Qué es un Testamento?

Es el **acto jurídico** por el cual una persona (testador) dispone de sus bienes y derechos para que sean transferidos a sus herederos después de su fallecimiento.

**Características:**
- **Personalísimo:** Solo puede hacerlo el testador
- **Unilateral:** No requiere aceptación previa de los herederos
- **Libre:** Puede revocarse o modificarse en cualquier momento
- **Formal:** Debe cumplir requisitos legales específicos

## Tipos de Testamento

### 1. Testamento Público Abierto

Se otorga ante **Notario Público**, en presencia de testigos.

**Ventajas:**
- **Seguridad jurídica:** Asesoría profesional del notario
- **Validez:** Menor riesgo de impugnación
- **Conservación:** Se integra al protocolo notarial
- **Claridad:** Redacción técnica precisa

**Proceso:**
1. Comparecencia ante notario
2. Manifestación de la voluntad del testador
3. Lectura del testamento
4. Firma del testador, notario y testigos
5. Autorización notarial

### 2. Testamento Público Cerrado

El testador entrega un sobre cerrado al notario, sin revelar su contenido.

**Características:**
- Mayor confidencialidad
- El notario no conoce el contenido hasta el fallecimiento
- Requiere mayor formalidad en la apertura

### 3. Testamento Ológrafo

Escrito de puño y letra por el testador.

**Requisitos:**
- Debe ser manuscrito completamente
- Fecha y firma del testador
- Debe depositarse ante notario para su validez

**Riesgos:**
- Mayor posibilidad de impugnación
- Puede perderse o destruirse
- Dificulta la interpretación

### 4. Testamentos Especiales

- **Testamento Privado:** En casos excepcionales (enfermedad grave)
- **Testamento Militar:** Para militares en campaña
- **Testamento Marítimo:** Para personas en altamar

## Proceso de Sucesión Testamentaria

### Fase 1: Fallecimiento del Testador

- Obtención del acta de defunción
- Localización del testamento
- Notificación a los herederos

### Fase 2: Apertura del Testamento

- Comparecencia ante notario o autoridad judicial
- Lectura del testamento
- Identificación de herederos y bienes

### Fase 3: Inventario y Avalúo

- Listado completo de bienes y derechos
- Valuación de los activos
- Identificación de pasivos (deudas)

### Fase 4: Partición y Adjudicación

- Distribución de los bienes conforme al testamento
- Pago de deudas y gastos funerarios
- Adjudicación a cada heredero

### Fase 5: Formalización

- Otorgamiento de escritura pública
- Inscripción en el Registro Público de la Propiedad
- Transmisión legal de la propiedad

## Ventajas de la Sucesión Testamentaria vs. Intestada

**Con Testamento:**
- ✅ Se respeta la voluntad del testador
- ✅ Proceso más ágil
- ✅ Menor conflicto entre herederos
- ✅ Claridad en la distribución de bienes
- ✅ Posibilidad de designar albacea de confianza

**Sin Testamento (Intestado):**
- ❌ La ley determina quiénes heredan
- ❌ Proceso más largo y costoso
- ❌ Mayor riesgo de conflictos familiares
- ❌ No se pueden hacer disposiciones especiales

## Elementos del Testamento

1. **Identificación del testador**
2. **Declaración de herederos** (quiénes recibirán los bienes)
3. **Descripción de bienes** (opcional, pero recomendable)
4. **Designación de albacea** (quien ejecutará el testamento)
5. **Cláusulas especiales** (legados, condiciones, etc.)

## Albacea

Es la persona designada por el testador para:

- Ejecutar las disposiciones testamentarias
- Administrar los bienes de la sucesión
- Pagar deudas y gastos
- Realizar la partición entre herederos
- Representar la sucesión legalmente

**Puede ser:**
- Un heredero
- Una persona de confianza
- Una institución especializada

## Legados

Son disposiciones testamentarias mediante las cuales se deja un bien específico a una persona determinada (legatario), sin que esta adquiera la calidad de heredero universal.

**Ejemplo:**
*"Dejo mi casa de la playa a mi sobrina María, y mi colección de arte a mi amigo Pedro."*

## Revocación del Testamento

El testador puede **modificar o revocar** su testamento en cualquier momento mientras viva y tenga capacidad legal.

**Formas de revocación:**
- Otorgando un nuevo testamento
- Declaración expresa de revocación
- Destrucción del testamento ológrafo

## Costos de la Sucesión Testamentaria

Los costos dependen de:
- Valor de los bienes
- Número de herederos
- Complejidad del patrimonio
- Honorarios del notario
- Impuestos (si aplican)

## Recomendaciones

1. **Haz tu testamento cuanto antes** – No esperes a estar enfermo
2. **Actualízalo periódicamente** – Conforme cambian tus circunstancias
3. **Asesórate con un notario** – Evita errores que invaliden el testamento
4. **Sé claro y específico** – Evita ambigüedades que generen conflictos
5. **Designa un albacea de confianza** – Alguien que ejecute fielmente tu voluntad

En la **Notaría Pública 90**, te asesoramos en la elaboración de tu testamento y acompañamos a tus familiares en el proceso de sucesión, garantizando certeza jurídica y tranquilidad para tu patrimonio.

*"El mejor regalo que puedes dejar a tu familia es un testamento claro y bien estructurado."*
    `
  },

  'compraventa-inmuebles': {
    slug: 'compraventa-inmuebles',
    title: 'Tip del Notario: Compraventa de bienes inmuebles con garantía hipotecaria',
    date: 'junio 14, 2025',
    category: 'Derecho Inmobiliario',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    image: 'https://images.unsplash.com/photo-1759429255330-51145b170dad?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1759429255330-51145b170dad?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Los créditos hipotecarios son préstamos a mediano y largo plazo que se usan para adquirir un bien inmueble.',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Compraventa de Bienes Inmuebles con Garantía Hipotecaria

Los **créditos hipotecarios** son una de las herramientas financieras más utilizadas para adquirir bienes inmuebles. Este mecanismo permite a las personas acceder a una vivienda mediante un préstamo a mediano o largo plazo, garantizado con el propio inmueble adquirido.

## ¿Qué es un Crédito Hipotecario?

Es un **préstamo otorgado por una institución financiera** (banco, Sofol, Infonavit, Fovissste) para la adquisición de un bien inmueble, donde:

- El inmueble queda en **garantía** (hipoteca)
- El comprador recibe el préstamo para pagar al vendedor
- El comprador paga mensualmente al acreedor durante el plazo pactado
- Al liquidar el crédito, se cancela la hipoteca

## Partes que Intervienen

1. **Comprador (Deudor Hipotecario):** Quien adquiere el inmueble y contrae la deuda
2. **Vendedor:** Propietario original del inmueble
3. **Acreedor Hipotecario:** Institución financiera que otorga el préstamo
4. **Notario Público:** Fedatario que formaliza la operación y garantiza su legalidad

## Proceso de Compraventa con Hipoteca

### Paso 1: Precalificación del Comprador

- Solicitud de crédito ante la institución financiera
- Evaluación de capacidad de pago
- Aprobación del monto del crédito

### Paso 2: Búsqueda y Selección del Inmueble

- Elección del inmueble a adquirir
- Negociación del precio con el vendedor
- Firma del contrato de promesa de compraventa (opcional)

### Paso 3: Avalúo del Inmueble

- La institución financiera ordena un avalúo oficial
- Se determina el valor comercial del bien
- El monto del crédito se basa en este avalúo

### Paso 4: Verificación Legal

El notario revisa:
- **Título de propiedad** del vendedor
- **Certificado de libertad de gravamen** (que no tenga deudas)
- **Certificado de no adeudo** de impuestos prediales y servicios
- **Licencia de construcción** y uso de suelo

### Paso 5: Elaboración de la Escritura

El notario prepara:
- **Escritura de compraventa**
- **Escritura de constitución de hipoteca**

Ambas pueden realizarse en un solo acto.

### Paso 6: Firma ante Notario

Comparecen:
- Vendedor
- Comprador
- Representante de la institución financiera

**Se realiza:**
- Lectura de las escrituras
- Firma de las partes
- Autorización del notario
- Entrega de cheques (del banco al vendedor)

### Paso 7: Pago de Impuestos y Derechos

- **Impuesto Sobre Adquisición de Inmuebles (ISAI)**
- **Derechos de registro**
- **Honorarios notariales**

### Paso 8: Inscripción en el Registro Público

- El notario tramita la inscripción
- Se registra la compraventa a nombre del comprador
- Se inscribe la hipoteca a favor del acreedor

### Paso 9: Entrega de Documentos

El comprador recibe:
- **Testimonio de la escritura**
- **Boleta de inscripción registral**
- El vendedor recibe el pago

## La Hipoteca como Garantía

**¿Qué implica la hipoteca?**

La hipoteca es un **derecho real de garantía** que:
- Asegura al acreedor el pago del crédito
- No implica pérdida de posesión (el comprador usa el inmueble)
- Otorga al acreedor el derecho de ejecutar la garantía en caso de impago

**Características:**
- **Accesoria:** Depende del crédito principal
- **Indivisible:** Garantiza la totalidad de la deuda
- **Inscribible:** Debe registrarse públicamente

## Obligaciones del Deudor Hipotecario

1. **Pagar puntualmente** las mensualidades
2. **Mantener el inmueble** en buen estado
3. **Pagar impuestos** y servicios del inmueble
4. **Contratar seguro** de daños (en muchos casos)
5. **No enajenar** sin consentimiento del acreedor

## Derechos del Deudor Hipotecario

- **Usar y disfrutar** el inmueble
- **Hacer mejoras** al bien
- **Solicitar cancelación** de hipoteca al liquidar el crédito
- **Pago anticipado** (en créditos que lo permitan)

## Tipos de Créditos Hipotecarios

### 1. Créditos Bancarios
- Otorgados por instituciones financieras privadas
- Tasas de interés variables o fijas
- Mayor flexibilidad en montos

### 2. Créditos del Infonavit
- Para trabajadores afiliados al IMSS
- Tasa de interés preferencial
- Requiere relación de trabajo formal

### 3. Créditos del Fovissste
- Para trabajadores al servicio del Estado
- Condiciones preferenciales
- Descuento vía nómina

### 4. Créditos Cofinanciados
- Combinación de dos fuentes (Ej: Infonavit + Banco)
- Permite acceder a mayores montos

## Cancelación de la Hipoteca

Una vez **liquidado el crédito**, se debe:

1. Solicitar carta de liberación al acreedor
2. Acudir al notario
3. Elaborar **escritura de cancelación de hipoteca**
4. Inscribirla en el Registro Público
5. El inmueble queda **libre de gravamen**

## Gastos Asociados

- **Avalúo:** $3,000 - $8,000 MXN
- **Investigación registral:** Variable
- **ISAI:** 2-5% del valor (según estado)
- **Honorarios notariales:** 1-3% del valor de la operación
- **Registro:** Variable por estado
- **Seguro de daños:** Anual

## Recomendaciones

1. **Compara diferentes opciones** de crédito antes de decidir
2. **Lee cuidadosamente** el contrato de crédito
3. **Verifica la situación legal** del inmueble antes de comprar
4. **Calcula tu capacidad de pago** considerando todos los gastos
5. **Asesórate con un notario** desde el inicio del proceso
6. **No firmes documentos** que no entiendas completamente

## Ventajas de Usar Crédito Hipotecario

- ✅ Acceso a vivienda sin tener el monto total
- ✅ Pago gradual a largo plazo
- ✅ Deducción de intereses en impuestos (en algunos casos)
- ✅ Construcción de patrimonio

## Riesgos a Evitar

- ❌ Sobreestimar tu capacidad de pago
- ❌ No verificar la situación legal del inmueble
- ❌ Ignorar los costos adicionales (mantenimiento, servicios)
- ❌ No leer el contrato de crédito

En la **Notaría Pública 90**, te acompañamos en todo el proceso de compraventa con hipoteca, garantizando que tu inversión inmobiliaria sea segura, legal y transparente.

*"Una vivienda es más que un inmueble; es el patrimonio y la tranquilidad de tu familia."*
    `
  },

  'poder-general': {
    slug: 'poder-general',
    title: 'Tip del Notario: Poder general para pleitos y cobranzas',
    date: 'junio 14, 2025',
    category: 'Derecho Civil',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    image: 'https://images.unsplash.com/photo-1767972463877-b64ba4283cd0?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1767972463877-b64ba4283cd0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Conforme al código civil es un MANDATO, instrumento el cual consta de tres facultades principales.',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Poder General para Pleitos y Cobranzas

El **Poder General para Pleitos y Cobranzas** es uno de los instrumentos jurídicos más utilizados en la práctica legal. Conforme al **Código Civil**, es un tipo de **mandato** mediante el cual una persona (poderdante) otorga facultades a otra (apoderado o mandatario) para representarla en asuntos judiciales y de cobranza.

## ¿Qué es un Poder?

Es un **acto jurídico** por el cual una persona (poderdante) confiere a otra (apoderado) la facultad de actuar en su nombre y representación.

**Marco Legal:**
- Código Civil (artículos relativos al mandato)
- Código de Procedimientos Civiles
- Ley del Notariado

## Tipos de Poder

### 1. Poder General
Faculta al apoderado para realizar múltiples actos dentro de una categoría específica.

### 2. Poder Especial
Faculta para realizar actos específicos y determinados.

## Clasificación de Poderes Generales

### A. Poder General para Pleitos y Cobranzas

Autoriza al apoderado para:
- **Representar** al poderdante en juicios y procedimientos legales
- **Iniciar demandas** a nombre del poderdante
- **Contestar demandas** en su representación
- **Ofrecer pruebas** y desahogarlas
- **Realizar cobranzas** judiciales y extrajudiciales
- **Firmar escritos** y promociones ante autoridades judiciales

### B. Poder General para Actos de Administración

Faculta para:
- Administrar bienes
- Celebrar contratos de arrendamiento
- Cobrar rentas
- Realizar reparaciones
- Contratar servicios

### C. Poder General para Actos de Dominio

Autoriza para:
- Comprar y vender bienes
- Hipotecar inmuebles
- Donar bienes
- Constituir sociedades
- Realizar actos de disposición

## Elementos del Poder para Pleitos y Cobranzas

Un poder completo debe contener:

1. **Identificación del Poderdante**
   - Nombre completo
   - Nacionalidad
   - Estado civil
   - Domicilio

2. **Identificación del Apoderado**
   - Mismos datos del poderdante
   - En caso de abogados, número de cédula profesional

3. **Facultades Conferidas**

**Facultades típicas:**

**I. Para Pleitos:**
- Promover toda clase de juicios
- Contestar demandas
- Reconvenir
- Ofrecer y desahogar pruebas
- Formular alegatos
- Interponer recursos
- Asistir a audiencias y diligencias
- Solicitar embargos y otras medidas cautelares

**II. Para Cobranzas:**
- Exigir y cobrar todo tipo de créditos
- Recibir pagos
- Otorgar recibos y finiquitos
- Ejercer acciones de cobro judicial
- Celebrar convenios de pago

**III. Facultades Adicionales:**
- Sustituir el poder (total o parcialmente)
- Delegar facultades específicas
- Revocar poderes otorgados por sustitución

4. **Cláusula de Sustitución**

Permite al apoderado delegar las facultades en otra persona.

**Tipos:**
- **Con reserva:** El apoderado conserva las facultades
- **Sin reserva:** El apoderado transfiere completamente las facultades

5. **Vigencia**
- Plazo determinado
- Indefinido (hasta revocación)

## Proceso de Otorgamiento

### Ante Notario Público

1. **Solicitud**
   - El poderdante acude al notario
   - Expresa su voluntad de otorgar poder
   - Define las facultades a conferir

2. **Identificación**
   - Presentación de identificación oficial vigente
   - Acreditación de capacidad legal

3. **Redacción**
   - El notario elabora el instrumento
   - Incluye todas las cláusulas necesarias

4. **Lectura y Firma**
   - Se lee el poder al poderdante
   - Firma del poderdante y apoderado (si está presente)
   - Autorización del notario

5. **Protocolo**
   - Se integra al protocolo notarial
   - Se expiden testimonios

### Ante Autoridad Judicial

También puede otorgarse compareciendo ante un juez, pero tiene menor alcance y validez limitada.

## Responsabilidades del Apoderado

El apoderado debe:
- Actuar **conforme a las instrucciones** del poderdante
- Obrar con **diligencia y buena fe**
- **Rendir cuentas** de su gestión
- **Informar** sobre el estado de los asuntos
- No usar el poder para **beneficio personal indebido**

## Derechos del Poderdante

- **Revocar** el poder en cualquier momento
- **Exigir rendición de cuentas**
- **Limitar** las facultades del apoderado
- **Supervisar** las acciones del apoderado

## Revocación del Poder

El poderdante puede revocar el poder:

1. **Otorgando escritura de revocación** ante notario
2. **Notificando** al apoderado
3. **Publicando** en caso de poderes públicos
4. **Inscribiendo** la revocación si el poder estaba registrado

**Efectos:**
- Cesa la representación
- El apoderado no puede seguir actuando
- Debe devolverse el original del poder

## Extinción del Poder

El poder se extingue por:
- **Revocación** del poderdante
- **Renuncia** del apoderado
- **Muerte** del poderdante o apoderado
- **Incapacidad sobrevenida** de alguna de las partes
- **Cumplimiento del plazo** (si lo tenía)

## Sustitución del Poder

El apoderado puede **sustituir** el poder cuando tiene esta facultad expresamente conferida.

**Forma de sustitución:**
- Ante notario público
- Indicando si es con o sin reserva
- El sustituto adquiere las mismas facultades

## Uso Indebido del Poder

**Consecuencias:**
- Responsabilidad **civil** (indemnización por daños)
- Responsabilidad **penal** (abuso de confianza, fraude)
- **Revocación inmediata**
- **Pérdida de honorarios**

## Costos

Los costos de un poder notarial dependen de:
- **Tipo de poder** (pleitos, administración, dominio)
- **Número de apoderados**
- **Arancel notarial** del estado

**Rango aproximado:** $2,000 - $5,000 MXN

## Recomendaciones

1. **Define claramente** las facultades que otorgas
2. **Elige un apoderado de confianza** – Preferentemente un profesional
3. **Especifica si puede sustituir** – Para evitar delegaciones no deseadas
4. **Establece límites** cuando sea necesario
5. **Revoca poderes** que ya no sean necesarios
6. **Conserva una copia** del poder otorgado
7. **Solicita rendición de cuentas** periódica

## Diferencia entre Poder y Carta Poder

| Concepto | Poder Notarial | Carta Poder |
|----------|----------------|-------------|
| **Formalidad** | Alta (ante notario) | Baja (firma ante 2 testigos) |
| **Alcance** | Amplio | Limitado |
| **Validez** | Plena fe pública | Restringida |
| **Uso** | Cualquier acto legal | Actos simples |
| **Costo** | Mayor | Menor |

## Cuándo Necesitas un Poder para Pleitos y Cobranzas

- Vas a **contratar un abogado** para que te represente en un juicio
- Necesitas que alguien **cobre deudas** en tu nombre
- Estás **fuera del país** y requieres representación legal
- Deseas que un profesional **gestione asuntos legales** complejos
- Necesitas **iniciar demandas** sin estar presente

En la **Notaría Pública 90**, te asesoramos en la elaboración de poderes con las facultades precisas que necesitas, garantizando tu seguridad jurídica y protegiendo tus intereses.

*"Un buen poder es la llave que abre las puertas de la justicia sin que tengas que estar siempre presente."*
    `
  },
  
  'constitucion-de-sociedad-mercantil': {
    slug: 'constitucion-de-sociedad-mercantil',
    title: 'Tip del Notario: Constitución de sociedad mercantil',
    date: 'junio 15, 2025',
    category: 'Derecho Mercantil',
    image: 'https://images.unsplash.com/photo-1773271042152-6a6c180f538f?crop=entropy&cs=srgb&fm=jpg&w=400&q=85',
    featuredImage: 'https://images.unsplash.com/photo-1773271042152-6a6c180f538f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    excerpt: 'Es de saber que tenemos el derecho de asociarnos con la finalidad de realizar actos de comercio o tener el interés de hacer negocios en nuestro país.',
    author: 'Abraham Cruz Zamudio',
    authorTitle: 'Notario Auxiliar en la Notaria 90',
    content: `
**Tip del Notario**

**Por: Abraham Cruz Zamudio**  
*Notario Auxiliar en la Notaria 90*

## Constitución de sociedad mercantil

Es de saber que tenemos el derecho de asociarnos con la finalidad de realizar actos de comercio o tener el interés de hacer negocios en nuestro país, por lo que podemos constituir sociedades de carácter mercantil las cuales son reconocidas por la **Ley General de Sociedades Mercantiles**.

El procedimiento para la constitución de una sociedad mercantil es solicitar ante la **Secretaría de Economía** la autorización de uso de denominación social para posteriormente acudir ante notario público quien le dará formalidad mediante una escritura pública e inscribirá ante el Registro Público de la Propiedad y del Comercio correspondiente para la obtención del **Folio Mercantil Electrónico**.

Así mismo en las sociedades mercantiles según su objeto social, pueden participar extranjeros observando que no sean actividades económicas reservadas a mexicanos o que tengan la cláusula de exclusión de extranjeros.

Las sociedades mercantiles según su régimen jurídico tienen características diferentes siendo las más comunes la **Sociedad Anónima y la Sociedad de Responsabilidad Limitada**.
    `
  }
};
